import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment';

import { OptimizedFertilizerRequest, OptimizedFertilizerResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class FertilizationLegalStandardApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = this.env.USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES
    ? `${this.env.APIM_BASE_URL}/arable-service/manure-space/fertilization-legal-standard`
    : `${this.env.API_BASE_URL}/service/field-report/secure/fertilizationlegalstandard/manureSpace`;

  getOptimizedFertilizer(request: OptimizedFertilizerRequest) {
    return this.http.post<OptimizedFertilizerResponse>(`${this.baseUrl}/fertilizer`, request);
  }
}
